/**
 * Estado de autenticação da aplicação
 * Baseado no auth_state_model.dart do Flutter
 */
export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: UserModel | null;
  tokens: AuthTokens | null;
  error: string | null;
  lastActivity: Date | null;
}

/**
 * Estado inicial da autenticação
 */
export const initialAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: false,
  user: null,
  tokens: null,
  error: null,
  lastActivity: null
};

/**
 * Estados de inicialização do MSAL
 */
export enum MsalInitializationState {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  INITIALIZING = 'INITIALIZING',
  INITIALIZED = 'INITIALIZED',
  FAILED = 'FAILED'
}

/**
 * Tipos de erro de autenticação
 */
export enum AuthErrorType {
  INITIALIZATION_ERROR = 'INITIALIZATION_ERROR',
  LOGIN_ERROR = 'LOGIN_ERROR',
  TOKEN_ERROR = 'TOKEN_ERROR',
  LOGOUT_ERROR = 'LOGOUT_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/**
 * Erro de autenticação estruturado
 */
export interface AuthError {
  type: AuthErrorType;
  message: string;
  code?: string;
  details?: any;
}

import { AuthTokens } from './auth-credentials.model';
import { UserModel } from './user.model';
